export default "__VITE_ASSET__ssyQ6ARk__"